import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";

interface Props {
  isDefaultLanguage: boolean;
}

/**
 * Component to display information about ASK when creating a new account.
 * @param params
 * @returns a box with texts.
 */
export const AskInfo = ({ isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <InfoBoxComponent header={texts.ASK_INFO_LINK}>
      <div className="flex pt-3">
        <Typography variant="H5">{texts.ASK_INFO_HEADER}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_INFO_1}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_INFO_2}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_INFO_3}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_INFO_4}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_INFO_5}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_INFO_6}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_INFO_7}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">
          {texts.ASK_INFO_8}
          <a
            href={"https://norne.no/verdipapirhandel/priser/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {texts.ASK_INFO_8_B}
          </a>
        </Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_INFO_9}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_INFO_10}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_INFO_11}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">
          <a
            href={"http://www.verdipapirforetakenessikringsfond.no/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {texts.ASK_INFO_11_B}
          </a>
          {texts.ASK_INFO_11_C}
        </Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_INFO_12}</Typography>
      </div>
      <div className="flex mt-3 pb-3">
        <Typography variant="Body">
          <a
            href={"http://www.bankenessikringsfond.no"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {texts.ASK_INFO_13}
          </a>
          {texts.ASK_INFO_14}
        </Typography>
      </div>
    </InfoBoxComponent>
  );
};
